'use client';

import React, { useMemo } from 'react';
import Heading from '../../src/components/Heading/Heading';
import { Button } from '@get-mosh/msh-shared';
import ComparisonCardsComponent from '../../src/components/Cards/ComparisonCards';
import { SliceComponentProps } from '@prismicio/react';
import { Content } from '@prismicio/client';

type ComparisonCardsProps = SliceComponentProps<Content.ComparisonCardsSlice>;

const ComparisonCards = ({ slice }: ComparisonCardsProps) => {
    const card1 = useMemo(
        () => ({
            label: slice.primary?.card_1_label || '',
            content: {
                heading: slice.primary?.card_1_title || '',
                includes: slice.primary?.card_1_description || '',
                price: slice.primary?.card_1_offer || '',
                list: slice.primary?.card_1_information as string[],
            },
        }),
        [slice],
    );

    const card2 = useMemo(
        () => ({
            label: slice.primary?.card_2_label || '',
            featured: true,
            featuredBgColor: slice.primary?.featured_background_color || '',
            content: {
                heading: (
                    <img
                        src={slice.primary.card_image.url || ''}
                        alt={slice.primary.card_image.alt || ''}
                        className="mb-4 w-[6rem] fill-white"
                    />
                ),
                includes: slice.primary?.card_2_description || '',
                price: slice.primary?.card_2_offer || '',
                list: slice.primary?.card_2_information as string[],
            },
        }),
        [slice],
    );

    const card3 = useMemo(
        () => ({
            label: slice.primary?.card_3_label || '',
            content: {
                heading: slice.primary?.card_3_title || '',
                includes: slice.primary?.card_3_description || '',
                price: slice.primary?.card_3_offer || '',
                list: slice.primary?.card_3_information as string[],
            },
        }),
        [slice],
    );

    const cardItems = [card1, card2, card3];

    return (
        <section
            style={{ backgroundColor: slice.primary.background_color || '' }}
        >
            <section className="py-8 lg:py-16">
                <div className="xl:container">
                    <Heading
                        centered={true}
                        level={'h2'}
                        className={'mb-8 px-4'}
                    >
                        {slice.primary.title}
                    </Heading>
                    <div className="relative pb-4">
                        <ComparisonCardsComponent cards={cardItems} />
                    </div>
                </div>
                {slice.primary.call_to_action_text ? (
                    <div className="container text-center">
                        <Button
                            as="a"
                            href={slice.primary.call_to_action_path || '/'}
                            text={slice.primary.call_to_action_text}
                            className="mx-auto mb-0"
                        />
                    </div>
                ) : null}
            </section>
        </section>
    );
};

export default ComparisonCards;
